import { decode } from 'jsonwebtoken';

const AUTH_STATE = 'auth-state';
let handleTokenUpdate = null;

export const decodeToken = (access_token = '') => {
  if (!access_token) return {};
  const decodedTokenData = decode(access_token);
  const { userData, rcToken } = decodedTokenData;
  return {
    ...userData,
    role: localStorage.getItem('role') || '',
    rcuser_uid: rcToken.owner_id,
    rc_access_token: rcToken.access_token,
  };
};

export const getToken = () => localStorage.getItem(AUTH_STATE) || '';

export const setToken = token => {
  localStorage.setItem(AUTH_STATE, token);

  if (handleTokenUpdate) {
    handleTokenUpdate();
  }
};

export const removeToken = () => {
  localStorage.removeItem(AUTH_STATE);
};

export const replaceToken = token => {
  localStorage.setItem(AUTH_STATE, token);
};

export const isJWTExpired = (token, alreadyDecoded) => {
  try {
    const { exp } = alreadyDecoded ? token : decode(token);
    if (Date.now() >= exp * 1000 - 300000) {
      return true;
    }
  } catch (err) {
    return true;
  }
  return false;
};

// eslint-disable-next-line consistent-return
export const onTokenUpdate = (callBack, accountUid) => {
  if (callBack) {
    handleTokenUpdate = callBack;
  }

  if (!callBack && handleTokenUpdate) {
    return handleTokenUpdate(accountUid);
  }
};
